import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { PageSubTitle } from 'Components/Titles';
import { StubLabel } from 'Components/Texts';
import { Modal } from 'Components/Modal';
import { EditEmailAddressModal } from './EditEmailAddressModal/EditEmailAddressModal';
import { updateEmail, updateUser } from 'Api/ProfileApi';
import { updateConfirmation } from 'State/Layouts/LayoutActions';
import { updateUserProfile } from 'State/User/UserActions';
import { onSubmitReactFormError } from 'Utils/FormValidation';
import './ManageProfile.css';
import { TRACKING_ENUMS, tealiumTrackEvent, trackEvent } from 'Utils/Analytics';
import { EditPasswordModal } from './EditPasswordModal/EditPasswordModal';

export const ManageProfile = ({ subTitle, routes, trackEditAccount }) => {
  const dispatch = useDispatch();
  const user = useSelector((s) => s.user);
  const [showEditEmailModal, setShowEditEmailModal] = useState(false);
  const [showEditPasswordModal, setShowEditPasswordModal] = useState(false);

  const onCloseEditEmailModal = () => {
    setShowEditEmailModal(false);
  };

  const onCloseEditPasswordModal = () => {
    setShowEditPasswordModal(false);
  };

  const onEditEmailFormSubmit = async ({ newEmailAddress, password }) => {
    const payload = {
      email: newEmailAddress.toLowerCase(),
      password,
    };
    const res = await updateEmail(profileId, payload);
    if (res?.email === payload.email) {
      const updatedUserProfile = { ...user, email: res.email };
      dispatch(updateUserProfile(updatedUserProfile));
      dispatch(updateConfirmation('Your email address has been updated.'));
      setShowEditEmailModal(false);
    } else {
      return onSubmitReactFormError('There was an issue updating your email. Please try again. ');
    }
  };

  const onEditPasswordFormSubmit = async ({ oldPassword, newPassword }) => {
    const payload = {
      password: oldPassword,
      newPassword,
      profileId,
      accessToken: user.accessToken,
    };
    const res = await updateUser(payload);
    if (res.profileId === undefined) {
      return onSubmitReactFormError('There was an issue updating your password. Please try again. ');
    } else {
      dispatch(updateConfirmation('Your password has been updated.'));
      setShowEditPasswordModal(false);
      trackEvent(TRACKING_ENUMS.EVENT_ACCOUNT_SETTING_FORGOT_PASSWORD, {
        page_item_title: 'Save Changes',
      });
      tealiumTrackEvent(TRACKING_ENUMS.EVENT_EDIT_PASSWORD_COMPLETED, {
        button_text: 'Save Changes',
        button_location: 'my account',
      });
      trackEvent(TRACKING_ENUMS.EVENT_ACCOUNT_SETTING_PASSWORD_UPDATED, {
        page_item_title: 'Save Changes',
      });
    }
  };

  const { email, firstName, lastName, hasMvpd, profileId } = user;

  if (hasMvpd) return null;
  return (
    <div className="sectionFlex profileSettings">
      <div className="sectionFlex flexGrowOne settingsSectionLeft">
        <PageSubTitle text={subTitle} />
      </div>
      <div className="sectionFlex flexDirCol flexGrowTwo settingsSectionRight">
        <div className="sectionFlex infoRow">
          <div className="sectionFlex infoRowLeft">
            <StubLabel className="profileLabel" text="Email:" />
            <div className="emailValue">
              <span className="stubValue" data-dd-privacy="mask" data-heap-redact-text>
                {email}
              </span>
            </div>
          </div>
          <div className="linksCol">
            <button
              onClick={() => {
                setShowEditEmailModal(true);
              }}
              className="profileLink"
            >
              <span className="profileLinkTest">Edit Email Address</span>
            </button>
          </div>
        </div>
        <div className="sectionFlex infoRow">
          <div className="sectionFlex infoRowLeft">
            <StubLabel className="profileLabel" text="Password:" />
            <span className="stubValue">............</span>
          </div>
          <div className="linksCol">
            <button
              onClick={() => {
                trackEditAccount('Edit Password');
                setShowEditPasswordModal(true);
              }}
              className="profileLink"
            >
              <span className="profileLinkTest">Edit Password</span>
            </button>
          </div>
        </div>
      </div>
      <Modal modernLayout isShowing={showEditEmailModal} onClose={onCloseEditEmailModal}>
        <EditEmailAddressModal show={showEditEmailModal} onFormSubmit={onEditEmailFormSubmit} />
      </Modal>
      <Modal modernLayout isShowing={showEditPasswordModal} onClose={onCloseEditPasswordModal}>
        <EditPasswordModal show={showEditPasswordModal} onFormSubmit={onEditPasswordFormSubmit} />
      </Modal>
    </div>
  );
};
